import api from 'api';
import { productValidationPayloadType } from 'type/productValidation';

const validateProduct = async (payload: productValidationPayloadType) => {
  const url = api.config.validateSku();
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  };

  const response = await fetch(url, requestOptions);
  return response;
};

export const productValidationService = {
  validateProduct
};
